import React, { FC } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { ReactComponent as ProgramType } from "../../../../assets/svg/program-type.svg";
import { ReactComponent as Location } from "../../../../assets/svg/location-inside-circle.svg";
import { ReactComponent as ProgramDuration } from "../../../../assets/svg/duration.svg";
import { IconWithText } from "../IconWithText";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    rowGap: "16px",
  },
  container: {
    fontSize: 16,
    color: "#858997",
    fontWeight: 500,
    marginTop: 7,
    paddingLeft: 50,
  },
  countryContainer: {
    maxWidth: 500,
    wordBreak: "break-all",
  },
  link: {
    fontSize: 16,
    color: "#7D9EF1",
    fontWeight: 500,
    "&:hover": {
      textDecoration: "none",
      color: "#5E88F1",
    },
  },
  iconTextContainerForLink: {
    display: "flex",
    columnGap: 10,
  },
}));

interface ProgramSubInfoShowProps {
  schoolCountry: string;
  programType: string;
  programDuration: string;
}

export const ProgramSubInfoWidget: FC<ProgramSubInfoShowProps> = ({
  schoolCountry,
  programType,
  programDuration,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.countryContainer}>
        <IconWithText Icon={Location} title="Country" />
        <div className={classes.container}>{schoolCountry}</div>
      </div>
      <div>
        <IconWithText Icon={ProgramType} title="Program Type" />
        <div className={classes.container}>{programType}</div>
      </div>
      <div>
        <IconWithText Icon={ProgramDuration} title="Program Duration" />
        <div className={classes.container}>{programDuration}</div>
      </div>
    </div>
  );
};
